(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nw-share-row"] && !Shopify.designMode) return;
  try {
    (() => {
    const showToast = (root, text) => {
      const toast = root.querySelector('[data-share-toast]');
      if (!toast) return;
      toast.textContent = text;
      toast.classList.add('is-visible');
      window.setTimeout(() => toast.classList.remove('is-visible'), 2200);
    };

    document.querySelectorAll('[data-nw-share]').forEach((root) => {
      if (root.dataset.shareReady === 'true') return;
      root.dataset.shareReady = 'true';

      const url = root.dataset.url || window.location.href;
      const title = root.dataset.title || document.title;
      const nativeButton = root.querySelector('[data-share-native]');

      if (nativeButton && typeof navigator.share === 'function') {
        nativeButton.hidden = false;
        nativeButton.addEventListener('click', () => {
          navigator.share({ title: title, url: url }).catch(() => {});
        });
      }

      const copyButton = root.querySelector('[data-share-copy]');
      if (copyButton) {
        copyButton.addEventListener('click', async () => {
          try {
            await navigator.clipboard.writeText(url);
            showToast(root, root.dataset.copiedText || 'Link copied');
          } catch (error) {
            window.prompt('Copy this link', url);
          }
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
